import { render, staticRenderFns } from "./sub-info.vue?vue&type=template&id=088e1cf8"
import script from "./sub-info.vue?vue&type=script&lang=js"
export * from "./sub-info.vue?vue&type=script&lang=js"
import style0 from "./sub-info.vue?vue&type=style&index=0&id=088e1cf8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports